// vi: filetype=javascript.jsx
import { connect } from "react-redux";
import { compose } from "recompose";
import EditableTool, { EditableToolProps } from "./EditableTool";
import { displayOpen, displayClose, remoteClose } from "src/pods/realtime";
import { createTool, fetchTools, editTool, deleteTool, selectTool, ToolkitDataSlice } from "src/pods/toolkitData";
import dispatchOnMount from "src/shared/hoc/dispatchOnMount";
import withRouteParams from "src/shared/hoc/withRouteParams";

type EditableToolContainerProps = {
  toolType: string;
  classId: string;
};

const mapStateToProps = (state: ToolkitDataSlice, props: EditableToolContainerProps) => {
  return {
    tools: selectTool(props.toolType, props.classId, state),
  };
};
const mapDispatchToProps = {
  displayOpen,
  displayClose,
  remoteClose,
  createTool,
  editTool,
  deleteTool,
};

type OuterProps = Omit<
  EditableToolProps,
  | "displayOpen"
  | "displayClose"
  | "remoteClose"
  | "createTool"
  | "editTool"
  | "deleteTool"
  | "tools"
  | "classId"
  | "mountPoint"
>;

export default compose<EditableToolProps, OuterProps>(
  withRouteParams(["classId", "mountPoint"]),
  connect(mapStateToProps, mapDispatchToProps),
  dispatchOnMount(fetchTools, (props) => ({
    classId: props.classId,
  })),
)(EditableTool);
